var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import Status from "./Status";
function PopUpMessage(props) {
    var type = props.type, message = props.message, setMessage = props.setMessage;
    var _a = useState(null), timeoutValue = _a[0], setTimeoutValue = _a[1];
    var clearMessage = function (timeout) {
        clearTimeout(timeoutValue);
        setTimeoutValue(setTimeout(function () {
            setMessage('');
        }, timeout));
    };
    useEffect(function () {
        clearMessage(10000);
    }, [message]);
    if (message === '')
        return _jsx(_Fragment, {});
    return ReactDOM.createPortal(
    // onClick clears pop-up
    _jsx("span", __assign({ onClick: function (e) {
            clearMessage(0);
            e.stopPropagation();
        }, className: "tol-pop-up-message" }, { children: _jsx(Status, { status: type, text: message }) })), document.body);
}
export default PopUpMessage;
